module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [(this.$store.state.core.user) ? _c('div', {
    staticClass: "uk-padding"
  }, [_c('ul', {
    staticClass: "uk-breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/pages"
    }
  }, [_vm._v("Pagina's")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'PageEdit',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("Bewerk pagina")])], 1)]), _vm._v(" "), _c('h1', [_vm._v("Bewerk Pagina")]), _vm._v(" "), _c('div', [_vm._l((_vm.sections), function(s, id) {
    return _c('div', {
      staticClass: "uk-card uk-card-default uk-card-body uk-margin-small"
    }, [_c('div', {}, [_c('div', {
      staticClass: "uk-align-left"
    }, [_c('p', {
      staticClass: "uk-card-title"
    }, [_vm._v(_vm._s(s.name))])]), _vm._v(" "), (_vm.$store.state.core.user.role >= 3) ? _c('div', {
      staticClass: "uk-align-right"
    }, [_c('span', {
      staticClass: "uk-link uk-margin",
      attrs: {
        "uk-icon": "icon: trash; ratio: 1"
      },
      on: {
        "click": function($event) {
          _vm.deleteSection(id)
        }
      }
    })]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
      staticClass: "uk-table"
    }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Veldnaam")]), _vm._v(" "), _c('th', [_vm._v("Waarde")]), _vm._v(" "), (_vm.$store.state.core.user.role >= 4) ? _c('th') : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((s.fields), function(field, key) {
      return _c('tr', [_c('td', {
        attrs: {
          "width": "30"
        }
      }, [_c('span', {
        staticClass: "uk-link uk-margin",
        attrs: {
          "uk-toggle": "",
          "href": "#field-modal",
          "uk-icon": "icon: pencil; ratio: 1.5"
        },
        on: {
          "click": function($event) {
            _vm.setEdit(id, key, field)
          }
        }
      })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(key))]), _vm._v(" "), (field.type == 'link') ? _c('td', [_c('a', {
        attrs: {
          "target": "_blank",
          "href": field.value.url
        }
      }, [_vm._v(_vm._s(field.value.text))])]) : (!_vm.isImage(field)) ? _c('td', [_vm._v(_vm._s(field.value))]) : _c('td', [_c('vue-image', {
        attrs: {
          "img": field.value,
          "size": 4
        }
      })], 1), _vm._v(" "), (_vm.$store.state.core.user.role >= 4) ? _c('td', {
        attrs: {
          "width": "30"
        }
      }, [_c('span', {
        staticClass: "uk-link uk-margin",
        attrs: {
          "uk-icon": "icon: trash; ratio: 1.2"
        },
        on: {
          "click": function($event) {
            _vm.deleteField(id, key)
          }
        }
      })]) : _vm._e()])
    }))]), _vm._v(" "), (_vm.$store.state.core.user.role >= 3) ? _c('div', {
      staticClass: "uk-placeholder uk-text-center uk-link",
      attrs: {
        "href": "#field-modal",
        "uk-toggle": ""
      },
      on: {
        "click": function($event) {
          _vm.setSelectedSection(id)
        }
      }
    }, [_c('span', {
      staticClass: "uk-padding-small",
      attrs: {
        "uk-icon": "icon: plus; ratio: 1"
      }
    }), _vm._v("VOEG VELD TOE")]) : _vm._e(), _vm._v(" "), _c('hr', {
      staticClass: "uk-text-primary uk-divider-icon"
    })])
  }), _vm._v(" "), (_vm.$store.state.core.user.role >= 3) ? _c('div', {
    staticClass: "uk-placeholder uk-text-center uk-link",
    attrs: {
      "href": "#section-modal",
      "uk-toggle": ""
    }
  }, [_c('span', {
    staticClass: "uk-padding-small",
    attrs: {
      "uk-icon": "icon: plus; ratio: 1"
    }
  }), _vm._v("VOEG SECTIE TOE")]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "section-modal",
      "uk-modal": ""
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog"
  }, [_c('button', {
    staticClass: "uk-modal-close-default",
    attrs: {
      "type": "button",
      "uk-close": ""
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-body"
  }, [_c('form', [_c('fieldset', {
    staticClass: "uk-fieldset"
  }, [_c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSection),
      expression: "newSection"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Naam"
    },
    domProps: {
      "value": (_vm.newSection)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newSection = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-footer"
  }, [_c('div', {
    staticClass: "uk-align-right"
  }, [_c('button', {
    staticClass: "uk-button uk-button-primary uk-align-right uk-modal-close",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.addSection
    }
  }, [_vm._v("Toevoegen")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-danger uk-align-right uk-modal-close"
  }, [_vm._v("Annuleren")])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "field-modal",
      "uk-modal": ""
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog"
  }, [_c('button', {
    staticClass: "uk-modal-close-default",
    attrs: {
      "type": "button",
      "uk-close": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-header"
  }, [(_vm.editing) ? _c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Veld bewerken")]) : _c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Veld toevoegen")])]), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-body"
  }, [_c('form', [_c('fieldset', {
    staticClass: "uk-fieldset"
  }, [_c('div', {
    staticClass: "uk-margin"
  }, [(!_vm.editing) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newField.name),
      expression: "newField.name"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Naam"
    },
    domProps: {
      "value": (_vm.newField.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newField, "name", $event.target.value)
      }
    }
  }) : _c('h3', [_vm._v(_vm._s(_vm.newField.name))])]), _vm._v(" "), (!_vm.editing) ? _c('ul', {
    attrs: {
      "uk-tab": ""
    }
  }, [_c('li', {
    staticClass: "uk-active"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.selectCurrentType('text')
      }
    }
  }, [_vm._v("Tekst")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.selectCurrentType('img')
      }
    }
  }, [_vm._v("Afbeelding")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.selectCurrentType('link')
      }
    }
  }, [_vm._v("Link")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.selectCurrentType('wysiwyg')
      }
    }
  }, [_vm._v("WYSIWYG")])])]) : _vm._e(), _vm._v(" "), (!_vm.editing) ? _c('div', [(_vm.currentType == 'text') ? _c('div', {
    staticClass: "uk-margin"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newField.value),
      expression: "newField.value"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Naam"
    },
    domProps: {
      "value": (_vm.newField.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newField, "value", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.currentType == 'img') ? _c('div', {
    staticClass: "uk-margin"
  }, [_c('image-picker', {
    on: {
      "choose": _vm.choose
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.currentType == 'link') ? _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newField.value.text),
      expression: "newField.value.text"
    }],
    staticClass: "uk-input uk-margin",
    attrs: {
      "type": "text",
      "placeholder": "Link tekst"
    },
    domProps: {
      "value": (_vm.newField.value.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newField.value, "text", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newField.value.url),
      expression: "newField.value.url"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "URL"
    },
    domProps: {
      "value": (_vm.newField.value.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newField.value, "url", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.currentType == 'wysiwyg') ? _c('div', {
    staticClass: "uk-margin"
  }, [_c('Vueditor', {
    ref: "editor"
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('div', [(_vm.newField.type == 'link') ? _c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newField.value.text),
      expression: "newField.value.text"
    }],
    staticClass: "uk-input uk-margin",
    attrs: {
      "type": "text",
      "placeholder": "Link tekst"
    },
    domProps: {
      "value": (_vm.newField.value.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newField.value, "text", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newField.value.url),
      expression: "newField.value.url"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "URL"
    },
    domProps: {
      "value": (_vm.newField.value.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newField.value, "url", $event.target.value)
      }
    }
  })]) : (typeof _vm.newField.value == 'object' || typeof _vm.newField.value == 'array') ? _c('div', {
    staticClass: "uk-margin"
  }, [_c('vue-image', {
    attrs: {
      "img": _vm.newField.value
    }
  }), _vm._v(" "), _c('image-picker', {
    staticClass: "uk-margin",
    attrs: {
      "multiple": typeof _vm.newField.value == 'array'
    },
    on: {
      "choose": _vm.choose
    }
  })], 1) : (_vm.newField.type == 'wysiwyg') ? _c('div', {
    staticClass: "uk-margin"
  }, [_c('Vueditor', {
    ref: "editor"
  })], 1) : _c('div', {
    staticClass: "uk-margin"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newField.value),
      expression: "newField.value"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Naam"
    },
    domProps: {
      "value": (_vm.newField.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newField, "value", $event.target.value)
      }
    }
  })])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-footer"
  }, [_c('div', {
    staticClass: "uk-align-right"
  }, [(_vm.editing) ? _c('button', {
    staticClass: "uk-button uk-button-primary uk-align-right uk-modal-close",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.editField($event)
      }
    }
  }, [_vm._v("Bewerken")]) : _c('button', {
    staticClass: "uk-button uk-button-primary uk-align-right uk-modal-close",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addField($event)
      }
    }
  }, [_vm._v("Toevoegen")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-danger uk-align-right uk-modal-close",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Annuleren")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-modal-header"
  }, [_c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Sectie toevoegen")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18199db7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CORE/modules/PAGES/PageEdit.vue
// module id = 507
// module chunks = 1